import { TdsFooter as Footer } from '@tencent/tds-ui-lite';
import React, { ComponentProps, FC } from 'react';

export const TdsFooter: FC<ComponentProps<typeof Footer>> = props => (
  <Footer {...props} />
);
